






















































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'

@Component
export default class ComponentIncluirNovasProducoes extends Vue {
  tableHeaders: any[] = [
    { text: 'Fonte Pagadora', value: 'fontePagadoraNome', align: 'left', sortable: false },
    { text: 'Prestador', value: 'prestadorNome', align: 'left', sortable: false },
  ]

  loadIncluirNovasProducoes: boolean = false

  get showModalIncluirNovasProducoes() { return this.getFinanceiroStore.modal.incluirNovasProducoes }
  set showModalIncluirNovasProducoes(value: boolean) { this.getFinanceiroStore.setModal({ name: 'incluirNovasProducoes', value }) }

  get loadingIncluirNovasProducoes() { return this.loadIncluirNovasProducoes }
  set loadingIncluirNovasProducoes(value: boolean) { this.loadIncluirNovasProducoes = value }

  async incluirNovasProducoes() {
    this.loadingIncluirNovasProducoes = true
    const response = await this.getFinanceiroStore.gerarRepasses()

    if (!response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Ocorreu um erro ao atualizar o repasse.', icon: 'warning', color: '#C62828' })
      this.loadingIncluirNovasProducoes = false
      return
    }

    EventBus.$emit('setSnackbar', { show: true, text: 'A atualização do repasse foi iniciada!', icon: 'done', color: '#2E7D32' })
    await this.getFinanceiroStore.getGeracaoDeRepassesItemsVisualizar(this.getFinanceiroStore.idForLoadValidacaoEGeracaoRepasse)
    this.showModalIncluirNovasProducoes = false
    this.loadingIncluirNovasProducoes = false
  }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }
}
